import { useStyles } from 'components/polls/shared/Question/Question.styles';
import { RadioList } from 'components/shared/form/RadioBox/RadioList';
import { useTranslator } from 'components/shared/hooks';
import { Heading } from 'components/shared/typography/Heading/Heading';
import { toOptions } from 'utils/api';
import { QuestionProps } from 'components/polls/Questionnaire/Questionnaire.types';
import React, { FC } from 'react';

export const SingleChoice: FC<QuestionProps> = ({ field, question, disabled }) => {
  const classes = useStyles();
  const trans = useTranslator();
  const options = toOptions(question.options, 'value', 'value');

  return (
    <div className={classes.question}>
      <Heading type="subtitle1" className={classes.title}>
        {question.title}&nbsp;
        {question.required && !disabled && trans('POLLS.QUESTIONNAIRE.ANSWER_REQUIRED')}
      </Heading>
      <RadioList
        name={`${field}.result`}
        options={options}
        disabled={disabled}
        containerClassName={classes.optionsList}
      />
    </div>
  );
};
